import { MEAN, PDOutputType, PERCENT } from '../../../shared';
import { EXPLORE_PANEL_ACTIONS } from './explorePanel.types';

export const ExplorePanelActionTypes: EXPLORE_PANEL_ACTIONS = {
  LOAD_SELECTORS_START: '[explorePanel] LOAD_SELECTORS_START',
  LOAD_SELECTORS_SUCCESS: '[explorePanel] LOAD_SELECTORS_SUCCESS',
  LOAD_SELECTORS_FAILURE: '[explorePanel] LOAD_SELECTORS_FAILURE',

  CHANGE_SELECTIONS: '[explorePanel] CHANGE_SELECTIONS'
};

export const CHART_SELECTIONS = {
  jurisdictionsSelected: '', // gets updated dynamically in reducer by selectorsResponse
  output: PDOutputType.OUTPUT_CHART,
  showStandardError: false,
  statistics: [MEAN, PERCENT],
  variablesSelected: '' // gets updated dynamically in reducer by selectorsResponse
};